import React, {useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import  'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import ApplicationPage from './pages/Solutions/ApplicationsPage';
import ScrollToTop from './components/ScrollToTop';
import CeoPage from './pages/CeoPage';

import AOS from 'aos';
import 'aos/dist/aos.css';
import NetworkPage from './pages/Solutions/NetworkPage';
import SystemsPage from './pages/Solutions/SystemsPage';
import ITCloudPage from './pages/Solutions/ITCloudPage';
import TermsCond from './pages/TermsCond';
import CookieBanner from './components/Cookies/CookieBanner';
import CookiePolicy from './pages/CookiePolicy';
import useAnalytics from './hooks/useAnalytics';
import ScrollToId from './hooks/ScrollToId';
import IndustriesPage from './pages/Sectors/IndustriesPage';
import BankingPage from './pages/Sectors/BankingPage';
import ServicesPage from './pages/Sectors/ServicesPage';
import ParticipationsPage from './pages/Structures/ParticipationsPage';
import ConseilsPage from './pages/Structures/ConseilsPage';
import TechnologiesPage from './pages/Structures/TechnologiesPage';
import SecuritePage from './pages/Structures/SecuritePage';
import JobOffers from './components/Jobs/JobOffers';
import JobDetails from './components/Jobs/JobDetails';
import PolitiqueConfidentialite from './pages/PoliticsPage';
import SatisfactionSurveys from "./components/Home/SatisfactionSurveys";

function App() {

  useEffect(() => {
    AOS.init({
      duration: 700,
      once: true,    
    });
  }, []);

  useAnalytics();

  return (
    <Router>
      <ScrollToTop/>
      <ScrollToId />
      <CookieBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/CeoMessage" element={<CeoPage/>}/>
        <Route path="/privacy" element={<PolitiqueConfidentialite/>}/>
        

        {/*Solutions*/}
        <Route path="/solutions/ApplicationsERP" element={<ApplicationPage/>}/>
        <Route path="/solutions/Reseau" element={<NetworkPage />}/>
        <Route path="/solutions/Systems" element={<SystemsPage/>}/>
        <Route path="/solutions/ITCloud" element={<ITCloudPage/>}/>
        <Route path="/CGU" element={<TermsCond />}/>
        <Route path="/Politique-cookies" element={<CookiePolicy />}/>

        {/*Sectors*/}
        <Route path="/secteurs/industries" element={<IndustriesPage/>} />
        <Route path="/secteurs/bancaire" element={<BankingPage/>} />
        <Route path="/secteurs/services" element={<ServicesPage/>} />

        {/*Structures*/}
        <Route path="/structures/participations" element={<ParticipationsPage/>} />
        <Route path="/structures/conseil" element={<ConseilsPage/>} />
        <Route path="/structures/technologies" element={<TechnologiesPage/>} />
        <Route path="/structures/securite" element={<SecuritePage/>} />


        {/*Jobs*/}
        <Route path="/jobs" element={<JobOffers/>} />
        <Route path="/jobs/:id" element={<JobDetails/>} />

        <Route path="/enquete-satisfaction" element={<SatisfactionSurveys />} />

      </Routes>
    </Router>
  );
}

export default App;